import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 根据粉丝wxid，获取粉丝扩展信息
export function webGetCustomFansExtendByWxid(wxid,callback){
	request({
			method: 'post',
			url: 'CustomFriendsExtend/getByWxid',
			data: {
			  wxid: wxid
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据粉丝wxid，获取粉丝扩展信息
export function webSaveCustomFansExtendByWxid(wxid,snsId,callback){
	request({
			method: 'post',
			url: 'CustomFriendsExtend/saveByWxId',
			data: {
			  wxid: wxid,
			  snsId:snsId
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据粉丝id，获取粉丝扩展信息
export function webGetCustomFansExtendById(id,callback){
	request({
			method: 'post',
			url: 'CustomFriendsExtend/getById',
			data: {
			  id: id
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据粉丝id，获取粉丝扩展信息
export function webSaveCustomFansExtendById(id,snsId,callback){
	request({
			method: 'post',
			url: 'CustomFriendsExtend/saveById',
			data: {
			  id: id,
			  snsId:snsId
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}